import acceptedCookiePolicy from "../../../components/onetrust/cookiePolicy";
import logAmplitudeEvent from "../../../components/amplitude";
import { decodeHtml } from "../utils/utils.common";
import { pageTypeIncludes } from "../dataLayers/utils/utils.dataLayer.common";
import md5 from 'js-md5';

const AmpLogFormSubmitted = (userEmail, marketoID, leadType, orgName) => {
    acceptedCookiePolicy({
        ifPerformanceCookies: () => {
            if (OnetrustActiveGroups.includes("C0004")) {
                const form = document.querySelector("[data-form-id]");
                const formID = form ? form.dataset.formId : "";
                const resourceType = document.querySelector("[data-resource-type]");
                const resourceTypeID = resourceType ? resourceType.dataset.resourceType.toLowerCase() : "";
                const formElements = document.querySelector("[data-form-id]")?.querySelector('form')['elements'];

                let hashedUserEmail = '';

                if (userEmail) {
                    hashedUserEmail = md5.create().update(userEmail).hex();
                }

                if (formID === "resources_details" && resourceType) {
                    if (userEmail) {
                        logAmplitudeEvent({
                            event_type: "Form Submitted",
                            setUserId: hashedUserEmail,
                            setUserProperties: {
                                marketo_id: marketoID,
                                internal: function determineSubmissionType() {
                                    if (userEmail.includes('@coveo.com') || userEmail.includes('test')) {
                                        return 'true';
                                    } else {
                                        return 'false';
                                    }
                                }(),
                                lead_type: leadType,
                            },
                            properties: {
                                submission_page: location.href.split("?")[0] || null,
                                submission_type: "Resource",
                                internal_submission: function determineSubmissionType() {
                                    if (userEmail.includes('@coveo.com') || userEmail.includes('test')) {
                                        return 'true';
                                    } else {
                                        return 'false';
                                    }
                                }(),
                                resource_type: decodeHtml(resourceTypeID),
                                contact_request_type: null
                            }
                        });
                    }
                }

                if (formID === "roi_calculator" && pageTypeIncludes("calculator")) {
                    if (userEmail) {
                        const hashParams = new URLSearchParams(location.hash.replace('#', ''));
                        const useCase = hashParams.get('use-case') ?? '';
                        
                        logAmplitudeEvent({
                            event_type: "submitted_roi_calculator",
                            setUserId: hashedUserEmail,
                            setUserProperties: {
                                marketo_id: marketoID,
                                internal: function determineSubmissionType() {
                                    if (userEmail.includes('@coveo.com') || userEmail.includes('test')) {
                                        return 'true';
                                    } else {
                                        return 'false';
                                    }
                                }(),
                                lead_type: leadType
                            },
                            properties: {
                                submission_page: location.href.split("?")[0] || null,
                                submission_type: useCase,
                                internal_submission: function determineSubmissionType() {
                                    if (userEmail.includes('@coveo.com') || userEmail.includes('test')) {
                                        return 'true';
                                    } else {
                                        return 'false';
                                    }
                                }(),
                                resourceType: null,
                                contact_request_type: null
                            }
                        });
                    }
                }

                if ((formID === "resources_details" && pageTypeIncludes("demo")) || pageTypeIncludes("gen-ai")) {
                    if (userEmail) {
                        logAmplitudeEvent({
                            event_type: "Form Submitted",
                            setUserId: hashedUserEmail,
                            setUserProperties: {
                                marketo_id: marketoID,
                                internal: function determineSubmissionType() {
                                    if (userEmail.includes('@coveo.com') || userEmail.includes('test')) {
                                        return 'true';
                                    } else {
                                        return 'false';
                                    }
                                }(),
                                lead_type: leadType
                            },
                            properties: {
                                submission_page: location.href.split("?")[0] || null,
                                submission_type: "Demo",
                                internal_submission: function determineSubmissionType() {
                                    if (userEmail.includes('@coveo.com') || userEmail.includes('test')) {
                                        return 'true';
                                    } else {
                                        return 'false';
                                    }
                                }(),
                                resource_type: null,
                                contact_request_type: null
                            }
                        })
                    }
                }

                if (formID === "contact_us") {
                    if (userEmail) {
                        logAmplitudeEvent({
                            event_type: "Form Submitted",
                            setUserId: hashedUserEmail,
                            setUserProperties: {
                                marketo_id: marketoID,
                                internal: function determineSubmissionType() {
                                    if (userEmail.includes('@coveo.com') || userEmail.includes('test')) {
                                        return 'true';
                                    } else {
                                        return 'false';
                                    }
                                }(),
                                lead_type: leadType,
                            },
                            properties: {
                                submission_page: location.href.split("?")[0] || null,
                                submission_type: "Contact us",
                                internal_submission: function determineSubmissionType() {
                                    if (userEmail.includes('@coveo.com') || userEmail.includes('test')) {
                                        return 'true';
                                    } else {
                                        return 'false';
                                    }
                                }(),
                                resourceType: null,
                                contact_request_type: function determineRequestType() {
                                    if (formElements) {
                                        const requestTypeFieldValue = formElements['Interest_on_Form__c']?.value;
                                        return requestTypeFieldValue;
                                    } else {
                                        return null;
                                    }
                                }()
                            }
                        })
                    }
                }

                if (pageTypeIncludes("free-trial")) {
                    if (userEmail) {
                        logAmplitudeEvent({
                            event_type: "Form Submitted",
                            setUserId: hashedUserEmail,
                            setUserProperties: {
                                marketo_id: marketoID,
                                internal: function determineSubmissionType() {
                                    if (userEmail.includes('@coveo.com') || userEmail.includes('test')) {
                                        return 'true';
                                    } else {
                                        return 'false';
                                    }
                                }(),
                                lead_type: leadType,
                                requested_free_trial: true
                            },
                            properties: {
                                submission_page: location.href.split("?")[0] || null,
                                submission_type: "Free trial",
                                internal_submission: function determineSubmissionType() {
                                    if (userEmail.includes('@coveo.com') || userEmail.includes('test')) {
                                        return 'true';
                                    } else {
                                        return 'false';
                                    }
                                }(),
                                resourceType: null,
                                contact_request_type: null
                            }
                        });
                    }
                }

                if (pageTypeIncludes(formID === "become_partner")) {
                    if (userEmail) {
                        logAmplitudeEvent({
                            event_type: "Form Submitted",
                            setUserId: hashedUserEmail,
                            setUserProperties: {
                                marketo_id: marketoID,
                                internal: function determineSubmissionType() {
                                    if (userEmail.includes('@coveo.com') || userEmail.includes('test')) {
                                        return 'true';
                                    } else {
                                        return 'false';
                                    }
                                }(),
                                lead_type: leadType,
                            },
                            properties: {
                                submission_page: location.href.split("?")[0] || null,
                                submission_type: "Partner",
                                internal_submission: function determineSubmissionType() {
                                    if (userEmail.includes('@coveo.com') || userEmail.includes('test')) {
                                        return 'true';
                                    } else {
                                        return 'false';
                                    }
                                }(),
                                resourceType: null,
                                contact_request_type: null
                            }
                        })
                    }
                }

            }
        }
    })
};

export default AmpLogFormSubmitted;